import { Button, CanvasAddPageIcon, Dialog, Divider, EditIcon, Flex, ListIcon, TrashCanIcon } from "@fluentui/react-northstar";
import { FullScreenPanel } from "modules/aad-user-details";
import React from "react";
import { SegmentContent } from "shared/components";
import { constants } from "shared/constants";
import pl from "shared/messages/pl";
import styles from "./notesTabContent.module.scss";


export interface INotesTabContentProps {
    isMobile: boolean;
    isEditNoteEnabled: boolean;
    notesList: JSX.Element;
    noteDetailsForm: JSX.Element;
    deleteNote: () => void;
    mobileFullScreenViewOpened: boolean;
    setMobileFullScreenViewOpened: (isOpen: boolean) => void;
    selectedNoteId: number | undefined;
    setSelectedNoteId: (selectedNote: number | undefined) => void;
    canNoteBeDeleted: boolean | undefined;
    isInEditMode: boolean;
    setEditMode: (editMode: boolean) => void;
}

const NotesTabContent: React.FC<INotesTabContentProps> = ({
    isMobile,
    isEditNoteEnabled,
    notesList,
    noteDetailsForm,
    deleteNote,
    mobileFullScreenViewOpened,
    setMobileFullScreenViewOpened,
    selectedNoteId,
    setSelectedNoteId,
    canNoteBeDeleted,
    isInEditMode,
    setEditMode,
}) => {

    if (isMobile) {
        const iconColor = (disabled: boolean) => {
            return disabled ? "#8a8a8a" : constants.actionIconColor;
        };

        return (
            <div className={styles.mobileWrapper}>
                <FullScreenPanel
                    onClose={() => setMobileFullScreenViewOpened(false)}
                    isOpen={mobileFullScreenViewOpened}
                >
                    {notesList}
                </FullScreenPanel>
                <SegmentContent>
                    <Flex gap="gap.large" styles={{ color: constants.actionIconColor }}>
                        <Button
                            icon={<ListIcon outline styles={{ color: constants.actionIconColor }} />}
                            iconOnly
                            title="NotesList"
                            onClick={() => {
                                setMobileFullScreenViewOpened(true);
                            }}
                        />
                        {isEditNoteEnabled && (<Flex gap="gap.smaller" styles={{ color: constants.actionIconColor }}>
                            <Button
                                icon={<CanvasAddPageIcon outline styles={{ color: constants.actionIconColor }} />}
                                iconOnly
                                title="Add"
                                onClick={() => setSelectedNoteId(undefined)}
                            />
                            <Button
                                icon={<EditIcon outline styles={{ color: iconColor(!selectedNoteId) }} />}
                                iconOnly
                                title="Edit"
                                onClick={() => setEditMode(true)}
                                disabled={!selectedNoteId}
                            />
                            <Dialog
                                cancelButton={pl.common.cancel}
                                confirmButton={pl.common.delete}
                                header={pl.notes.confirmNoteDeletion}
                                trigger={
                                    <Button
                                        icon={
                                            <TrashCanIcon
                                                outline
                                                styles={{ color: iconColor(!canNoteBeDeleted || isInEditMode) }}
                                            />
                                        }
                                        iconOnly
                                        title="Close"
                                        disabled={!canNoteBeDeleted || isInEditMode}
                                    />
                                }
                                onConfirm={() => {
                                    deleteNote();
                                }}
                            />
                        </Flex>)}
                    </Flex>
                    <Divider />
                    {noteDetailsForm}
                </SegmentContent>
            </div>
        );
    }

    return (
        <Flex style={{ height: "100%" }}>
            <Flex.Item shrink>
                <SegmentContent style={{ width: "auto" }}>{notesList}</SegmentContent>
            </Flex.Item>
            <Flex.Item grow>
                <SegmentContent>{noteDetailsForm}</SegmentContent>
            </Flex.Item>
        </Flex>
    );
}

export default NotesTabContent;